import React, { useEffect } from 'react';


export default class BodyTag extends React.Component{  
  componentDidMount() {
    let { className } = this.props;
    document.body.classList.add(..._.castArray(className));
  }
  componentWillUnmount() {
    let { className } = this.props;
    document.body.classList.remove(..._.castArray(className));
  }
  render() {
    return <React.Fragment />;
  }
}

export const BodyDisableScroll = ({...props}) => {
  useEffect(() => {
    document.body.classList.add('lock-scroll');
    return () => document.body.classList.remove('lock-scroll');
  }, [])
  return null;
}